import clarity from '@microsoft/clarity';
import { HHMT_THEME } from 'constants';

const isEnabled = process.env.REACT_APP_CLARITY_ENABLED === 'true';

let initialised = false;
let trackingAllowed = true;

const getClarityProjectId = () => {
  const isHHMT = process.env.REACT_APP_APP_NAME === HHMT_THEME;
  return isHHMT
    ? process.env.REACT_APP_CLARITY_PROJECT_ID_HHMT
    : process.env.REACT_APP_CLARITY_PROJECT_ID_REMOX;
};

const callClarity = (...args) => {
  if (typeof window === 'undefined') return;
  if (typeof window.clarity !== 'function') return;

  window.clarity(...args);
};

const useClarity = () => {
  const init = () => {
    if (!isEnabled || !trackingAllowed || initialised) return;

    clarity.init(getClarityProjectId());
    initialised = true;
  };

  const identify = (customId, customSessionId, customPageId) => {
    if (!isEnabled || !trackingAllowed) return;
    if (typeof window.clarity !== 'function') return;

    clarity.identify(customId, customSessionId, customPageId);
  };

  const stop = () => {
    if (!isEnabled || !trackingAllowed) return;

    callClarity('event', 'business_session_ended');

    callClarity('consent', false);

    trackingAllowed = false;
    initialised = false;
  };

  const clarityAPI = { init, identify, stop };

  return { clarityAPI };
};

export default useClarity;
